/**
 * @generated SignedSource<<6cb9f03c9760e6c15c0d15cf8ca24f4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "comment"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customerRelationRating"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deliveryRating"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "qualityRating"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "comment",
        "variableName": "comment"
      },
      {
        "kind": "Variable",
        "name": "customerRelationRating",
        "variableName": "customerRelationRating"
      },
      {
        "kind": "Variable",
        "name": "deliveryRating",
        "variableName": "deliveryRating"
      },
      {
        "kind": "Variable",
        "name": "orderId",
        "variableName": "orderId"
      },
      {
        "kind": "Variable",
        "name": "qualityRating",
        "variableName": "qualityRating"
      }
    ],
    "concreteType": "Order",
    "kind": "LinkedField",
    "name": "RateOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rowId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowedCustomerActions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primeCustomerAction",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RateOrderModalMutation",
    "selections": (v5/*: any*/),
    "type": "ClientAppMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RateOrderModalMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "b1f89dc3f2ce238685f379a32e3abfd2",
    "id": null,
    "metadata": {},
    "name": "RateOrderModalMutation",
    "operationKind": "mutation",
    "text": "mutation RateOrderModalMutation(\n  $orderId: Int!\n  $qualityRating: Int!\n  $deliveryRating: Int!\n  $customerRelationRating: Int!\n  $comment: String\n) {\n  RateOrder(orderId: $orderId, qualityRating: $qualityRating, deliveryRating: $deliveryRating, customerRelationRating: $customerRelationRating, comment: $comment) {\n    id\n    rowId\n    allowedCustomerActions\n    primeCustomerAction\n    status\n  }\n}\n"
  }
};
})();

node.hash = "390ade9f71f39a21442ecae169c7f1b8";

module.exports = node;
